


















































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import {
  HsaBankStatementListItem,
  FetchState,
  HsabDocumentType,
  HsabSsoDestination
} from "@/shared/types";
import { ResourcesDocuments as CurrentPageRoute } from "@/employee/route-names";
import moment from "moment";
import _ from "lodash";
import { useHsaBankStatements } from "@/employee/store/hsaBankStatements";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { docTypeIconMap } from "@/shared/awesomeIconMapper";

interface DocumentItem {
  dateGenerated: moment.Moment;
  linkTitle: string;
  downloadAction: () => Promise<any>;
  key: string;
  isLoading: boolean;
  isDisabled: boolean;
  docType: HsabDocumentType;
}

@Component({
  components: {
    GenericLoadingSpinner,
    SsoDeepLink
  }
})
export default class CombinedStatements extends Vue {
  docTypeIconMap = docTypeIconMap;
  hsaBankStatements = useHsaBankStatements();
  featureFlagStore = useFeatureFlagStore();
  HsabDocumentType = HsabDocumentType;

  @Prop()
  year: number;

  get hsabStatementsDeeplinkLocation () {
    return HsabSsoDestination.Statements;
  }

  get isLoading () {
    return this.featureFlagStore.featureFlagsLoadedState === false ||
      this.hsaBankStatements.isPageStatementsLoaded === false;
  }

  get nextYear () {
    return this.year + 1;
  }

  get previousYear () {
    return this.year - 1;
  }

  get showNextYear () {
    return this.hsaBankStatements.canViewNextYearStatements;
  }

  get showPreviousYear () {
    return this.hsaBankStatements.canViewPreviousYearStatements;
  }

  get toPreviousYear () {
    return {
      name: CurrentPageRoute,
      query: {
        year: this.previousYear
      }
    };
  }

  get toNextYear () {
    return {
      name: CurrentPageRoute,
      query: {
        year: this.nextYear
      }
    };
  }

  get hasItemsForYear (): boolean {
    return this.documentItems.length > 0;
  }
  get documentItems () {
    return this.hsaBankStatements.monthlyStatementsForYear
          .map(this.mapStatementToDocumentItem);
  }
  mapStatementToDocumentItem (item: HsaBankStatementListItem): DocumentItem {
    const dateGenerated = moment(item.dateGenerated);
    const datePeriodStart = moment(item.datePeriodStart);
    const linkTitle = item.title;
    const openStatementMethod = item.hsabDocumentType === HsabDocumentType.NonHsaAccountSummary
     ? this.hsaBankStatements.openNotionalStatementLocation
     : this.hsaBankStatements.openStatementLocation;
    const downloadAction = () => openStatementMethod({
      identifier: item.identifier,
      linkTitle,
      docType: item.hsabDocumentType
    });

    return {
      dateGenerated,
      downloadAction,
      linkTitle,
      key: `monthly-statement-${datePeriodStart.format()}`,
      isLoading: this.hsaBankStatements.monthlyStatementPdfs[item.identifier].fetchState === FetchState.Loading ||
        this.hsaBankStatements.monthlyStatementLocations[item.identifier].fetchState === FetchState.Loading,
      isDisabled: false,
      docType: item.hsabDocumentType
    };
  }
  onDownloadClick (item: DocumentItem) {
    item.downloadAction();
  }
  mounted () {
    this.loadPage();
  }

  @Watch("year")
  loadPage () {
    this.hsaBankStatements.loadStatementsForPage(this.year);
  }
}

